import { ChatInput as SharedChatInput } from "@/components/chat/ChatInput";
import { WebSearchToggle } from "./WebSearchToggle";

interface Props {
  onSendMessage: (message: string) => void;
  isStreaming: boolean;
  isReady: boolean;
  compact?: boolean;
  placeholder?: string;
  isWebSearchEnabled?: boolean;
  onToggleWebSearch?: () => void;
  onCancel?: () => void;
}

export const ChatInput = ({
  onSendMessage,
  isStreaming,
  isReady,
  compact = false,
  placeholder,
  isWebSearchEnabled,
  onToggleWebSearch,
  onCancel,
}: Props) => (
  <div className="pb-4">
    <SharedChatInput
      onSendMessage={onSendMessage}
      isStreaming={isStreaming}
      isReady={isReady}
      compact={compact}
      placeholder={placeholder}
      onCancel={onCancel}
      bottomSlot={
        onToggleWebSearch ? (
          <div className="pt-1">
            <WebSearchToggle isEnabled={!!isWebSearchEnabled} onToggle={onToggleWebSearch} />
          </div>
        ) : undefined
      }
    />
  </div>
);
